import { render, staticRenderFns } from "./PurchaseListTable.vue?vue&type=template&id=7497a27e&"
import script from "./PurchaseListTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports